import { StyleSheet } from 'react-native';

import { EnhancedInlineAlert } from '@fhs/ui';
import {
  CHECKOUT_PAYMENT_ERROR_ALERT,
  CHECKOUT_PRICING_ALERT,
} from '@fhs-legacy/frontend/src/utils/test-ids';

import type { PaymentPipelineError } from '../../../payment/payment-types';

export function PricingAlert() {
  return (
    <EnhancedInlineAlert
      status="error"
      title="Pricing Error"
      message="There was an error processing your order. Please try again. Error code: (Price Mutation Error)"
      isDismissable={false}
      onDismiss={() => {}}
      style={styles.alert}
      testID={CHECKOUT_PRICING_ALERT}
    />
  );
}

export function ConfirmingOrderAlert() {
  return (
    <EnhancedInlineAlert
      status="warning"
      title="Confirming Your Order"
      message="It looks like there's a temporary connection issue. Please don't refresh or leave this page. We'll automatically take you to your receipt as soon as the connection is restored."
      isDismissable={false}
      onDismiss={() => {}}
      style={styles.alert}
    />
  );
}

export function PaymentErrorAlert({
  error,
  onClear,
}: {
  error: PaymentPipelineError;
  onClear: () => void;
}) {
  return (
    <EnhancedInlineAlert
      status="error"
      title={getPaymentErrorTitle(error.code)}
      message={`${error.userMessage || error.message}`}
      isDismissable
      onDismiss={onClear}
      style={styles.alert}
      testID={CHECKOUT_PAYMENT_ERROR_ALERT}
    />
  );
}

function getPaymentErrorTitle(errorCode: string | undefined): string {
  switch (errorCode) {
    case 'COMMIT_ORDER_COOLING_PERIOD':
      return 'Duplicate Orders';
    case 'COMMIT_ORDER_LOYALTY_VALIDATION':
      return 'Loyalty Validation Error';
    case 'COMMIT_ORDER_UNCONFIRMED':
      return 'Order Status Unknown';
    default:
      return 'Payment Error';
  }
}

const styles = StyleSheet.create({
  alert: { marginBottom: 4, borderRadius: 2 },
});
